import { effect, Injectable, signal } from '@angular/core';
import { Guides, GuideType, VisaGuide, cm } from '@sp-shared';
import { RouteNames, Routes } from '../enums/routes.enum';
import { DirectoryTile } from '../interfaces/directory-tile.interface';
import { ConfigService } from './config.service';
import { GuidesService } from './guides.service';

import { LogService } from './log.service';
@Injectable({
	providedIn: 'root'
})
export class VisaService {
	guidesId = '';
	visasSignal = signal<VisaGuide[] | null>(null);
	constructor(
		private guidesService: GuidesService,
		private configService: ConfigService,
		private log: LogService
	) {}

	init = effect(() => {
		const guides = this.guidesService.guidesSignal();
		if (cm.isNotEmpty(guides)) {
			this.handleGuidesUpdate(guides);
		}
	});

	visasGuide(): VisaGuide[] | null {
		return this.visasSignal();
	}

	handleGuidesUpdate(guides: Guides): void {
		this.guidesId = guides.id;
		if (guides.visaGuides?.length > 0) this.visasSignal.set(guides.visaGuides);
	}

	getFavoriteTiles(favorites: string[]): DirectoryTile[] {
		const visas = this.visasSignal().filter(visa => favorites.includes(visa.id));
		this.log.debug('visas', visas);

		let tiles: DirectoryTile[] = [];
		for (const visa of visas) {
			tiles.push({
				id: visa.id,
				title: visa?.name,
				type: GuideType.Visa,
				label: '',
				url: this.configService.setupLink(RouteNames.Visas, [visa?.name?.toLowerCase()]),
				bookmarked: true,
				color: 'mustard'
			} as DirectoryTile);
		}

		return tiles;
	}
}
